import request from './request'



export function pushEmail(query){
    return request({
        url: 'customerApi/email',
        method: 'post',
        data: query
    });
}

export function getCountryCode(query){
    return request({
        url: 'customerApi/ip/countrycode',
        method: 'post',
        data: query
    });
}